import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/1 homescreen/webp/cover-ill_1.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/1 homescreen/webp/cover-ill.xs_1.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/2 does this sound familiar/webp/cloud.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/about/webp/Tamara.webp");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/heroCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LastCTA"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/LastCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/PricingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SurveyBenefitSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/SurveyBenefitSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/TestimonialsSection.tsx");
